import React, { useMemo, useState, useNavigate } from "react";
import axios from "axios";
import Costanti from "../../constantiX";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column, InputText } from "primereact";

import MultiLanguageDialog from "../MultiLanguageDialog";
import { initValue } from "../../util";

class ListaStoria extends React.Component {
  constructor() {
    super();
    this.actions = [
      {
        id: 1,
        icon: "pi-search",
        label: "",
        action: (id) => {
          this.vai(id, "V");
          console.log("View " + id);
        },
      },
      {
        id: 2,
        icon: "pi-pencil",
        label: "",
        action: (id) => {
          this.vai(id, "U");
          console.log("Update " + id);
        },
      },
      {
        id: 3,
        icon: "pi-trash",
        label: "",
        action: (id) => {
          this.vai(id, "D");
          console.log("Delete " + id);
        },
      },
    ];
    this.state = {
      activePage: 0,
      lista: [],
      totalRecords: 0,
      first: 0,
      rows: 10,
      loading: true,
      visible1: false,
    };
    this.token = sessionStorage.getItem("ICEtoken");
    this.utente = JSON.parse(sessionStorage.getItem("utente"));
    this.state = {
      xcarica: "sezione",
      imgsrc: "",
      dati: [],
      totalRecords: 0,
      pageSize: 10,
      first: 0,
      isDialogVisible: false,
      visible2: false,
      visible3: false,
      singolo: {},
      activePage: 1,
      tipo: null,
    };
    this.onPage = this.onPage.bind(this);
    this.hasImage = false;
  }
  componentDidMount() {
    this.aziendaid = this.utente.aziendaid;
    this.caricaDati(1, this.state.pageSize);
    this.stato = this.props.stato;
    if (this.stato == "U") {
      this.actions.push(
        {
          id: 2,
          icon: "pi-pencil",
          label: "",
          action: (id) => {
            this.vai(id, "U");
            console.log("Update " + id);
          },
        },
        {
          id: 3,
          icon: "pi-trash",
          label: "",
          action: (id) => {
            this.vai(id, "D");
            console.log("Delete " + id);
          },
        },
      );
    }
  }

  caricaDati(pagina, numrec) {
    let config = {
      headers: {
        Authorization: "Bearer " + this.token,
      },
    };
    this.setState({ loading: true });
    var quer = "page=" + pagina + "&num=" + numrec + "&aziendaid=" + this.aziendaid;
    axios
      .get(Costanti.UrlCallApi + "aziendastory/all?" + quer, config)
      .then((res) => {
        res.data.lista1.forEach((element) => {
          element.azioni = this.actions;
        });
        const rowItemVal = [];
        const traduzioneArray = res.data.lista1.map((item) => item.traduzione);
        const caratteristicaIdArray = res.data.lista1.map((item) => item.id);
        traduzioneArray.forEach((el, index) => {
          const filteredValue = el.filter((item) => item.lingua === "it");
          const nome = filteredValue.find((item) => item.nomecampo === "nome");
          const descrizione = filteredValue.find((item) => item.nomecampo !== "nome");
          const fieldValue = {
            nome: nome ? nome.testo : "",
            descrizione: descrizione ? descrizione.testo : "",
            id: caratteristicaIdArray[index],
          };
          rowItemVal.push(fieldValue);
        });
        this.setState({ materie: rowItemVal, totalRecords: res.data.conta1, loading: false });
      })
      .catch((error) => {
        alert(error);
      });
  }
  onPage(event) {
    this.setState({
      loading: true,
      activePage: event.page + 1,
      first: event.first,
    });
    this.caricaDati(event.page + 1, this.state.pageSize);
  }

  setDialogVisible(val) {
    this.setState({ isDialogVisible: val });
    this.caricaDati(this.state.activePage, this.state.pageSize);
  }

  vai(id, tipo) {
    this.setDialogVisible(true);
    this.setState({ tipo: tipo });
    switch (tipo) {
      case "A":
        this.state.singolo = {};
        this.setState({ editMode: true, singolo: {}, intestazione: "Aggiungi Story" });
        break;
      case "V":
        this.setState({ intestazione: "Visualizza Story" });
        break;
      case "D":
        this.setState({ intestazione: "Elimina Story" });
        break;
      case "U":
        this.setState({ editMode: true, intestazione: "Modifica Story" });
        break;
    }
    if (tipo !== "A") {
      this.caricaSingolo(id, tipo);
    }
  }

  async caricaSingolo(id, tipo) {
    let config = {
      headers: {
        Authorization: "Bearer " + this.token,
      },
    };
    axios
      .get(Costanti.UrlCallApi + "aziendastory/" + id, config)
      .then((res) => {
        this.setState({ singolo: res.data, loading: false });
        this.id = res.data.id;
        this.hasImage = res.data.hasImage;
        this.settaImg();

        this.setState({ tipo: tipo });
        switch (tipo) {
          case "A":
            this.setState({ editMode: true, intestazione: "Aggiungi Story" });
            break;
          case "V":
            this.setState({ intestazione: "Visualizza Story" });
            break;
          case "D":
            this.setState({ intestazione: "Elimina Story" });
            break;
          case "U":
            this.setState({ editMode: true, intestazione: "Modifica Story" });
            break;
        }
        this.setDialogVisible(true);
      })
      .catch((error) => {
        this.id = 0;
        alert(error);
      });
  }
  settaImg() {
    var testo =
      Costanti.UrlCallApi + "file/get/" + this.utente.aziendaid + "/aziendaStoria/" + this.id + "?" + Math.random();
    this.setState({ imgsrc: testo });
  }
  salva(values) {
    let config = {
      headers: {
        Authorization: "Bearer " + this.token,
      },
    };
    this.setState({ isSubmitting: true });
    if (this.state.tipo == "D") {
      values.status = "E";
      axios
        .post(Costanti.UrlCallApi + "aziendastory/salva/" + this.state.singolo.id, values, config)
        .then((res) => {
          this.showMessage("success", "Dati salvati correttamente", "");
          this.setState({ isSubmitting: false });
        })
        .catch((error) => {
          this.showMessage("error", "Errore nel salvataggio", error.message);
          this.setState({ isSubmitting: false });
        });
    }
    if (this.state.tipo == "U") {
      axios
        .post(Costanti.UrlCallApi + "aziendastory/salva/" + this.state.singolo.id, values, config)
        .then((res) => {
          this.showMessage("success", "Dati salvati correttamente", "");
          this.setState({ isSubmitting: false });
        })
        .catch((error) => {
          this.showMessage("error", "Errore nel salvataggio", error.message);
          this.setState({ isSubmitting: false });
        });
    }
    if (this.state.tipo == "A") {
      var dato = {
        datains: null,
        dataupd: null,
        id: 0,
        nome: values.nome,
        descrizione: values.descrizione,
        nomeen: values.nomeen,
        descrizioneen: values.descrizioneen,
        aziendaid: this.aziendaid,

        uteins: 1,
        uteupd: null,
        status: " ",
      };
      axios
        .post(Costanti.UrlCallApi + "aziendastory/aggiungi", dato, config)
        .then((res) => {
          this.showMessage("success", "Dati salvati correttamente", "");
          this.setState({ isSubmitting: false });
        })
        .catch((error) => {
          this.showMessage("error", "Errore nel salvataggio", error.message);
          this.setState({ isSubmitting: false });
        });
    }
  }



  render() {
    console.log(this.state.singolo);
    return (
      <div>
        <DataTable
          value={this.state.materie}
          rows={this.state.pageSize}
          totalRecords={this.state.totalRecords}
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks CurrentPageReport NextPageLink LastPageLink"
          currentPageReportTemplate="	(pag. {currentPage} di {totalPages}) "
          paginator={true}
          onPage={this.onPage}
          loading={this.state.loading}
          lazy={true}
          first={this.state.first}
          header={
            <div className="mb-1 flex align-items-center justify-content-between">
              <span className="text-xl font-medium text-900">Lista Storie</span>
              <InputText type="search" className="border-none" placeholder="Cerca..." />

              <Button
                label="Aggiungi"
                onClick={() => this.vai(0, "A")}
                icon="pi pi-plus"
                className="p-button-rounded p-button-primary "
              />
            </div>
          }
          responsiveLayout="stack"
        >
          <Column
            field="id0"
            body={(item) => (
              <img
                width="45px"
                src={
                  Costanti.UrlCallApi +
                  "file/get/" +
                  this.utente.aziendaid +
                  "/aziendaStoria/" +
                  item.id +
                  "?" +
                  Math.random()
                }
                alt=""
              />
            )}
          />
          <Column id="id1" field="nome" header="Nome" style={{ width: 250 }} />
          <Column id="id2" field="descrizione" header="Descrizione" />

          <Column
            id="id5"
            field="id"
            header="Azioni"
            style={{ width: 250 }}
            body={(item) => (
              <div className="product-list-action flex" style={{ alignItems: "center", gap: "1rem" }}>
                {this.actions.map((action) => (
                  <Button
                    key={action.id}
                    className="p-button-sm"
                    icon={`pi ${action.icon}`}
                    label={action.label}
                    aria-label={action.label}
                    onClick={(e) => {
                      e.stopPropagation();
                      action.action(item.id);
                    }}
                  />
                ))}
              </div>
            )}
          ></Column>
        </DataTable>

        {((this.state.singolo && Object.keys(this.state.singolo).length > 0) || this.state.tipo === "A") && (
          <MultiLanguageDialog
            hasImage={true}
            title={this.state.intestazione}
            isVisible={this.state.isDialogVisible}
            operationType={this.state.tipo}
            itemId={this.state.singolo.id || 0}
            contents={this.state.singolo}
            initValue={initValue}
            onClose={() => this.setDialogVisible(false)}
            table={"aziendastory"}
            labelImg={"Immagine"}
            label={["Nome", "Descrizione"]}
            itemToAdd={{
              datains: null,
              dataupd: null,
              id: 0,
              aziendaid: this.aziendaid,
              uteins: 1,
              uteupd: null,
              status: " ",
            }}
          />
        )}
      </div>
    );
  }
}

export default ListaStoria;
